import React, { Component, ReactNode } from 'react'
import styled from 'styled-components'
import { SmallStyle } from 'components/styled/typography/styles'
import { Errors, ModelGetterFn } from 'react-redux-form'
import { I18nComponentType } from 'i18n/i18n-types'
import { mapLanguageToComponentProps } from 'i18n'
import { connect, useStore } from 'react-redux'

interface FormErrorsProps {
  model: string | ModelGetterFn
  i18n: I18nComponentType
  show?: boolean | { touched?: boolean; focus?: boolean }
  messages?: object
  expand?: boolean
}

const FormErrorsWrapper = styled.div<{ $expand: boolean }>`
  min-height: ${({ theme, $expand }) => ($expand ? 'auto' : theme.space.s12)};
  height: auto;
  margin-bottom: ${({ theme }) => theme.space.s4};
  color: ${({ theme }) => theme.color.error110};
  line-height: ${({ theme }) => theme.space.s16};
  font-size: ${({ theme }) => theme.space.s12};

  div {
    &::before {
      content: '* ';
    }
  }

  > * {
    ${SmallStyle};
    color: ${({ theme }) => theme.color.error110};
  }
`

interface ErrorBoundaryState {
  hasError: boolean
}

class FormErrorsBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: { children: ReactNode }) {
    if (this.state.hasError && prevProps.children !== this.props.children) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

export const FormErrors = ({
  model,
  show = { touched: true, focus: false },
  i18n,
  messages,
  expand = false,
}: FormErrorsProps) => {
  const store = useStore()
  return (
    <FormErrorsWrapper $expand={expand}>
      <FormErrorsBoundary>
        <Errors
          // @ts-ignore
          store={store}
          model={model}
          show={show}
          messages={{ ...i18n.formErrors, ...messages }}
        />
      </FormErrorsBoundary>
    </FormErrorsWrapper>
  )
}

export default connect(mapLanguageToComponentProps())(FormErrors)
